import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Wrench, GraduationCap } from 'lucide-react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import careersHeroImage from '../../images/AboutUs/AboutUs.jpg';
import './Careers.css';

/** Email for job applications — update here if needed */
const CAREERS_EMAIL = 'kirbooindia@gmail.com';

const Careers = () => {
  const openings = [
    {
      icon: <Wrench className="w-10 h-10" />,
      title: 'Expert Valve Technician',
      description:
        'Skilled valve technicians with hands-on experience in inspection, repair, refurbishment, and field service for industrial valves.',
      emailSubject: 'Application - Expert Valve Technician'
    },
    {
      icon: <GraduationCap className="w-10 h-10" />,
      title: 'On-site Service engineer',
      description:
        'Experienced service engineers with strong technical knowledge and troubleshooting capability. Must be willing to travel across Pan India and internationally (abroad) to support on-site valve and actuator servicing, diagnostics, and project requirements.',
      emailSubject: 'Application - On-site Service engineer'
    }
  ];

  const mailtoHref = (subject) =>
    `mailto:${CAREERS_EMAIL}?subject=${encodeURIComponent(subject)}`;

  return (
    <div className="careers-page">
      <section
        className="careers-hero"
        style={{ backgroundImage: `url(${careersHeroImage})` }}
      >
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="careers-hero-content"
          >
            <Breadcrumb />
            <h1 className="careers-hero-title">
              <span className="careers-hero-title-highlight">Careers</span> at KirBOO Flowsafe
            </h1>
            <p className="careers-hero-description">
              Join our team of experts. We welcome qualified professionals who share our commitment to quality and
              safety in industrial flow control.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="careers-openings">
        <div className="container-custom">
          <div className="careers-openings-grid">
            {openings.map((role, index) => (
              <motion.article
                key={role.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="careers-card"
              >
                <div className="careers-card-icon">{role.icon}</div>
                <h2 className="careers-card-title">{role.title}</h2>
                <p className="careers-card-description">{role.description}</p>
                <p className="careers-card-label">Apply by email</p>
                <a href={mailtoHref(role.emailSubject)} className="careers-card-email">
                  <Mail className="w-5 h-5 flex-shrink-0" />
                  {CAREERS_EMAIL}
                </a>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      <section className="careers-cta">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="careers-cta-inner"
          >
            <p className="careers-cta-text">Have questions before you apply?</p>
            <Link to="/contact" className="careers-cta-link">
              Contact us
            </Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Careers;

